import type { RpcError } from "../types/rpc.types";

export class RpcRequestError extends Error implements RpcError {
  status?: number;
  code?: number;
  data?: unknown;

  constructor(message: string, status?: number, code?: number, data?: unknown) {
    super(message);
    this.name = 'RpcRequestError';
    this.status = status;
    this.code = code;
    this.data = data;
  }
}
